/**
 * @generated SignedSource<<69bbe73a85af9dc2332b7cf7f1b16b6a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type loginAzureActiveDirectory_Query$variables = {};
export type loginAzureActiveDirectory_Query$data = {
  readonly viewer: {
    readonly component: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"loginAzureActiveDirectory_viewer">;
  } | null;
};
export type loginAzureActiveDirectory_Query = {
  variables: loginAzureActiveDirectory_Query$variables;
  response: loginAzureActiveDirectory_Query$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "login_azure_active_directory"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"login_azure_active_directory\")"
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "loginAzureActiveDirectory_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "loginAzureActiveDirectory_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "loginAzureActiveDirectory_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "actualPersonId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "AADTenant",
                "storageKey": null
              },
              (v1/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "28b2df6670d5247aeb006653cf5b8b77",
    "id": null,
    "metadata": {},
    "name": "loginAzureActiveDirectory_Query",
    "operationKind": "query",
    "text": "query loginAzureActiveDirectory_Query {\n  viewer {\n    component(name: \"login_azure_active_directory\")\n    ...loginAzureActiveDirectory_viewer\n    id\n  }\n}\n\nfragment loginAzureActiveDirectory_viewer on Viewer {\n  id\n  actualPersonId\n  company {\n    AADTenant\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "6eefc5d1571be80a52f9cba805a6bc6e";

export default node;
